// Central user-facing date/time formatting (Croatian default).
// Uses Intl with the hr-HR locale, which renders the Croatian standard "12. lipnja 2026."
// (day + genitive month + year, with periods). Route ALL user-facing dates through here.
// The backend has the server-side equivalent in helpers/dateformat.py.

export function formatDate(value, locale = "hr-HR") {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(d);
}

export function formatDateTime(value, locale = "hr-HR") {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}
